import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, CODE, COMBO_BOX } = FIELD_TYPE;

const dataInputAnaysis: DataFormField[] = [
  {
    type: CODE,
    label: "Mã phiếu khám",
    expand: false,
    name: "maPhieuKham",
    placeholder: "Nhập",
  },
  {
    type: CODE,
    label: "Mã bệnh nhân",
    expand: false,
    name: "maBenhNhan",
    placeholder: "Nhập",
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    expand: false,
    name: "tenBenhNhan",
  },
  {
    type: DATE,
    label: "Ngày sinh",
    expand: false,
    name: "ngaySinh",
  },

  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "gioiTinh",
    options: [
      { value: null, label: "Tất cả" },
      { value: 0, label: "Nam" },
      { value: 1, label: "Nữ" },
    ],
    expand: true,
  },
  {
    type: CODE,
    label: "Số thẻ BHYT",
    placeholder: "Nhập...",
    name: "soTheBHYT",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    expand: true,
    name: "soDienThoai",
  },
  // {
  //   type: INPUT,
  //   label: "Bác sĩ chỉ định",
  //   placeholder: "Nhập...",
  //   name: "bacSyChiDinh",
  //   expand: true,
  // },
  {
    type: COMBO_BOX,
    label: "Trạng thái BH",
    placeholder: "Chọn",
    name: "trangThaiBH",
    options: [
      { value: 0, label: "Chưa có" },
      { value: 1, label: "Hết hạn" },
      { value: 2, label: "Hiệu lực" },
    ],
    expand: true,
  },
  {
    type: COMBO_BOX,
    label: "Loại KCB",
    placeholder: "Chọn",
    name: "loaiKCB",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày tạo từ",
    placeholder: "DD/MM/YY",
    name: "ngayTaoTu",
    expand: true,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
    disableDate: false,
  },
  {
    type: DATE,
    label: "Ngày tạo đến",
    placeholder: "DD/MM/YY",
    name: "ngayTaoDen",
    expand: true,
    disableDate: false,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái XN",
    placeholder: "Chọn",
    expand: true,
    name: "trangThai",
    options: [
      { value: null, label: "Tất cả" },
      { value: "0", label: "Phiếu khám mới" },
      { value: "1", label: "Chờ thực hiện" },
      { value: "2", label: "Đang thực hiệnn" },
      { value: "3", label: "Hoàn thành" },
      { value: "4", label: "Chờ kết quả xét nghiệm" },
      { value: "5", label: "Đã có kết quả xét nghiệm" },
      { value: "6", label: "Hủy thực hiện" },
      { value: "7", label: "Đã xóa" },
    ],
  },
  {
    type: COMBO_BOX,
    label: "Khu KCB",
    placeholder: "Chọn",
    name: "khuKham",
    expand: true,
  },
];

export default dataInputAnaysis;
